<ngx-paypal class="paypal-form" [config]="payPalConfig"></ngx-paypal>